import client from './client'
import ANONYMITY_LOGIN from '@/constants/anonymity-login'

export default {
  async anonymityLogin () {
    const url = '/public/v1/anonymity/login'
    const {DEVICE_ID, DEVICE_NAME, DISTINCT_ID} = ANONYMITY_LOGIN
    const res = await client.post(url, { deviceId: DEVICE_ID, deviceName: DEVICE_NAME, distinctId: DISTINCT_ID }, {
      headers: {platform: 'GROOT'}
    })
    return res && res.data && res.data.data
  },
  async refresh (refresh) {
    const url = '/public/v1/refresh'
    const res = await client.post(url, { refresh })
    return res && res.data && res.data.data
  },
  async wxLogin (data) {
    const url = '/public/v1/oauth/login'
    const res = await client.post(url, data, {headers: {platform: 'GROOT'}})
    return res && res.data
  },
  // 微信静默授权
  async wxSlientAuthLogin (data) {
    const url = '/public/v1/oauth/base/login'
    const res = await client.post(url, data, {headers: {platform: 'GROOT'}})
    return res && res.data
  }
}



// WEBPACK FOOTER //
// ./src/apis/auth-api/login.js